export const openPdf = (fileLink: string) => {
  const link = document.createElement('a');
  link.href = fileLink;
  link.setAttribute('download', 'attachment.pdf');
  link.setAttribute('target', '_blank');
  document.body.appendChild(link);
  link.click();
}